import { useEffect, useMemo } from 'react';
import { Scheme } from '../types';
import BoardPresenter from '../addons/board-presenter';
import Fade from '../addons/fadeIn';
import Static from '../canvases/static';

/**
 * Презентер, привязанный к канве: живёт столько же, сколько компонент, и переинициализируется
 * при смене менеджера канвы.
 */
export default function useBoardPresenter(manager: Static | undefined, fade: Fade) {
  const presenter = useMemo(() => new BoardPresenter(), []);

  useEffect(() => {
    if (!manager) return;
    presenter.init({
      getObjects: () => manager.canvas.getObjects(),
      fadeOut: (objects) => fade.fadeOut(objects),
      load: (scheme: Scheme) => manager.loadLocal({ scheme }),
      clear: () => manager.clear(),
      setStaleCheck: (isStale) => {
        manager.isStaleRender = isStale;
      },
    });
  }, [manager, fade, presenter]);

  return presenter;
}
